/**
 * Manage the main site navigation
 * @params {*} none
 * @return {function} initializes the main site navigation
 */
const navigation = (function() {
  "use strict"

  const init = () => {
    const header = document.querySelector(".js-header");
    const mainMenu = document.querySelector(".js-main-menu");
    const page = document.body;

    header.addEventListener("click", e => {
      // click on hamburger opens/closes the overlay and the main navigation
      if (e.target.matches(".js-hamburger, .js-hamburger *")) {
        page.classList.toggle("menu-active")
      }
    });

    mainMenu.addEventListener("click", e => {
      // click on any menu link closes the main navigation and the overlay
      if (e.target.matches("a")) {
        // close overlay and menu
        page.classList.remove("menu-active")
      }
    })
  };
  
  return { init }
  
}());

export default navigation;